import type { FC } from 'react';

interface LoadingBarProps {
  visible: boolean;
}

export const LoadingBar: FC<LoadingBarProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="w-full h-1 bg-muted overflow-hidden mt-4">
      <div className="h-full w-1/3 bg-success rounded-full animate-loading-bar" />
    </div>
  );
};
